import React from 'react';

import {StepConfigUISchemaWithTabs, isTabbedUISchema} from '../StepConfigEditorTypes';
import StepConfigEditorRouter, {StepConfigEditorRouterProps} from './StepConfigEditorRouter';
import StepConfigFormTabContainer, {StepConfigFormTabContainerProps} from './StepConfigFormTabContainer';

type StepConfigFormProps = {
  uiSchema: StepConfigUISchemaWithTabs;
  clientStateId: string;
} & (Omit<StepConfigEditorRouterProps, 'uiSchema'> | Omit<StepConfigFormTabContainerProps, 'uiSchema'>); // Typescript has a hard time combining the uiSchema prop

export default function StepConfigForm(props: StepConfigFormProps): JSX.Element {
  if (isTabbedUISchema(props.uiSchema)) {
    return (
      <StepConfigFormTabContainer {...props} clientStateId={props.clientStateId} uiSchema={props.uiSchema} />
    );
  }

  return <StepConfigEditorRouter {...props} uiSchema={props.uiSchema} />;
}
